import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum, AppButton,AppAction,AppRow} from 'qcc'
import api, {PosProjectFundReplace} from "api";

export default class SetReplaceForm extends React.PureComponent<AppFormPageProps> {

    handleSave = () =>{
        this.refForm.current && this.refForm.current.save();
    }

    save = async () =>{
        let posProjectFundReplace = this.refForm.current.getFormData()  as PosProjectFundReplace ;
        await api.posprojectfund.setReplaceName(posProjectFundReplace);
        return {result:true}
    }


    close= async ()=>{
        AppAction.closeDialog()
    }

    
    refForm = React.createRef<AppForm>();
   
    render() {
        let {formData,mode,id} = this.props;
        let {templateOptionList} = formData;
        return (<AppFormLayout >
            <AppFormLayout.Form>
                <AppForm entity='' loadingData={false} mode={mode} keyValue={id} formData={formData} 
                    afterSave={()=>{this.props.afterSave && this.props.afterSave()}} save={this.save}
                    ref = {this.refForm}
                >
                        <AppForm.Section labelWidth={120} >
                        <AppForm.Item label='款项名称'
                        field='name' 
                        itemType={AppFormItemEnum.label} readonly  />

                        <AppForm.Item label='款项票据名称'
                        field='replaceName' 
                        itemType={AppFormItemEnum.input} req />
                         
                        </AppForm.Section>
                        </AppForm>
            </AppFormLayout.Form>
            <AppFormLayout.Footer>
                <AppRow>
                    <AppButton label="保存" type='primary' action={() => this.handleSave()}/> 
                    <AppButton label="关闭"  action={() => this.close()}/>
                </AppRow>
            </AppFormLayout.Footer>
        </AppFormLayout>)
    }
}


// WEBPACK FOOTER //
// ./src/page/pos/projectfund/SetReplaceForm.tsx